import StylingActionsTypes from '../../styling/const/ActionsTypes';
import Constants from '../../../constants/actions';
const {
  CHANGE_SURVEY_SETTING,
  CLEAR_SURVEY_SECTION,
  FINISH_BLOCK_ORDER_PERSISTENCE,
  FINISH_HEADER_PERSISTENCE,
  FINISH_REMOVE_BLOCK,
  FINISH_UPDATE_BLOCK_LIST,
  PERSIST_BLOCK_UPDATE_REQUEST,
  SET_LANDING_PAGE_ENABLED_STATE,
  SET_SHARED_HEADER,
  SET_SURVEY_HEADER_END_ENABLED,
  SET_SURVEY_HEADER_LANDING_ENABLED,
  SET_SURVEY_HEADER_QUESTIONS_ENABLED,
  TOGGLE_SURVEY_FULL_WIDTH,
} = Constants;

export const changeStylingActionList = [
  StylingActionsTypes.FINISH_LOCAL_STYLING_PERSISTENCE,
];

const headerChangeActions = [
  FINISH_HEADER_PERSISTENCE,
  SET_SHARED_HEADER,
  SET_SURVEY_HEADER_END_ENABLED,
  SET_SURVEY_HEADER_LANDING_ENABLED,
  SET_SURVEY_HEADER_QUESTIONS_ENABLED,
];

const blockEditorActions = [
  FINISH_BLOCK_ORDER_PERSISTENCE,
  PERSIST_BLOCK_UPDATE_REQUEST,
  FINISH_UPDATE_BLOCK_LIST,
  FINISH_REMOVE_BLOCK,
  CLEAR_SURVEY_SECTION,
];

const settingsActions = [
  SET_LANDING_PAGE_ENABLED_STATE,
  TOGGLE_SURVEY_FULL_WIDTH,
  CHANGE_SURVEY_SETTING,
];

export default [
  ...changeStylingActionList,
  ...headerChangeActions,
  ...blockEditorActions,
  ...settingsActions,
];
